import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  selectAll,
  selectEntities,
  WorkflowWebhookState,
} from './workflow-webhooks.reducer';

export const selectWorkflowWebhookState =
  createFeatureSelector<WorkflowWebhookState>('workflowWebhookState');

export const selectWorkflowWebhooks = createSelector(
  selectWorkflowWebhookState,
  (state: WorkflowWebhookState) => selectAll(state),
);
export const selectWorkflowWebhooksEntities = createSelector(
  selectWorkflowWebhookState,
  (state: WorkflowWebhookState) => selectEntities(state),
);
export const selectIsLoading = createSelector(
  selectWorkflowWebhookState,
  ({ isLoading }: WorkflowWebhookState) => isLoading,
);
export const selectIsSaving = createSelector(
  selectWorkflowWebhookState,
  ({ isSaving }: WorkflowWebhookState) => isSaving,
);
export const selectCreatedId = createSelector(
  selectWorkflowWebhookState,
  ({ createdId }: WorkflowWebhookState) => createdId,
);
